import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { webCampaignBaseUrl } from '../app/apis';

/**
 * Right side boxes
 */
import Boxes from '../components/Boxes';


/**
 * Page Header
 */
import Header from '../components/Header';


/**
 * Router
 */
import Router from '../router';


/**
 * App initial Setup
 */
import setup from './SETUP';


/**
 * Campagin intractions
 */
import handleCampaign from './helpers';


const RcawContainer = styled.div`
  padding: 15px;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 635px;
  min-height: 635px;
`;


const WgwContainer = styled.div`

  background-color: white;
  box-shadow: 0 2px 12px 0px rgba(0,0,0,0.15);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
  height: auto;
  overflow: auto;

  /* 
  ##Device = Desktops
  ##Screen = 1281px to higher resolution desktops
  */


  @media (min-width: 1281px) {
    float: left;
    width: calc(50% - 5px);
  }

  /* 
    ##Device = Laptops, Desktops
    ##Screen = B/w 1025px to 1280px
  */

  @media (min-width: 1025px) and (max-width: 1280px) {
    float: left;
    width: calc(50% - 5px);
  }

  /* 
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
  */

  @media (min-width: 768px) and (max-width: 1024px) {
    float: left;
    width: calc(50% - 5px);
  }

  /* 
    ##Device = Tablets, Ipads (landscape)
    ##Screen = B/w 768px to 1024px
  */

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    float: left;
    width: calc(50% - 5px);
  }

  /* 
    ##Device = Low Resolution Tablets, Mobiles (Landscape)
    ##Screen = B/w 481px to 767px
  */

  @media (min-width: 481px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 17px;
  }

  /* 
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
  */

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    margin-bottom: 17px;
  }

  /* 
    ##Device = smallest smart phones
    ##Screen = max 319px
  */

  @media (max-width: 319px) {
    width: 100%;
    margin-bottom: 17px;
  }
`;

const RCAW = ({
  pluginId,
  hasCampaign,
  projectId,
  districtId,
  uuid,
  lang
}) => {
  /**
   * Setup Application with pluginId
   */
  useEffect(() => {
    window.addEventListener('message', campaignMessageHandler, false);
    setup(pluginId);
  }, [pluginId]);


  const campaignMessageHandler = (event) => {
    if (typeof event.data === 'string') {
      handleCampaign(event.data);
    }
  };

  const campaignLink = () => `${webCampaignBaseUrl}/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${lang}&zones=&runson=webapp`;

  return (
    <div>
      <Header />
      <RcawContainer className="clearfix">
        {
          hasCampaign
            ? (
              <Iframe
                title="Campaign"
                src={campaignLink()}
              />
            ) : (
              <div>
                <WgwContainer>
                  <Router />
                </WgwContainer>
                <Boxes />
              </div>
            )
        }
      </RcawContainer>
    </div>
  );
};

export default connect((state) => ({
  hasCampaign: state.campaign.isCampaignActive && Object.keys(state.campaign.campaignInfo).length,
  projectId: state.app.projectId,
  districtId: state.app.districtId,
  uuid: state.app.uuid,
  lang: state.config.lang,
}))(RCAW);
